<template>
<div container--fluid>
    <v-layout>
        <BookingModule></BookingModule>
    </v-layout>
</div>
</template>

<script>
import BookingModule from '@modules/booking/index.vue';

export default {
    name: 'booking',
    components: {
        BookingModule,
    },
    data(){
        return {
            //
        }
    },
};
</script>

<style scoped>

</style>
